/**
 * Capture transform for WidgetPieChart.
 *
 * The pie sizes itself purely through percentage heights (ResponsiveContainer
 * 100%/100% inside a fixed-height container), so nothing is ever clipped and
 * there is nothing to expand. Left alone, the generic flow's
 * `min-width: max-content` step un-wraps the horizontal legend and blows the
 * capture up to several thousand px wide. Pin the chart container to its
 * on-screen width so the capture is WYSIWYG (legend keeps wrapping, the
 * ResizeObserver-driven radius doesn't reshuffle mid-capture).
 *
 * Returns a restore() function.
 */
export const preparePieChart = async (containerElement) => {
  const chart = containerElement.querySelector(".pieChartCompContainer");
  if (!chart) return () => {};

  const rect = chart.getBoundingClientRect();
  const saved = {
    width: chart.style.width,
    maxWidth: chart.style.maxWidth,
  };
  chart.style.width = rect.width + "px";
  chart.style.maxWidth = rect.width + "px";

  return () => {
    chart.style.width = saved.width;
    chart.style.maxWidth = saved.maxWidth;
  };
};
